APP.carSelector = function () {
	const el = $('.car-selector');

	const slickCarSelector = $('.slick--car-selector');
	const slickCarItemLength = $('.slick--car-selector .slick__item').length;
	const isMinLength = slickCarItemLength > 3;

	function init() {
		if (el.length === 0) return;

		slickCarSelector.slick({
			infinite: true,
			centerMode: isMinLength,
			centerPadding: '180px',
			slidesToShow: isMinLength ? 3 : 4,
			slidesToScroll: isMinLength ? 3 : 4,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						arrows: false,
						infinite: true,
						centerMode: true,
						centerPadding: '60px',
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

		el.on('click', '.car-selector__main', handleCarSelectorClick);
	}

	function handleCarSelectorClick(e) {
		const obj = $(this);
		const href = obj.attr('href');

		if (!href || !href.startsWith('#')) return;

		e.preventDefault();

		const taberLink = $('.taber__link');
		if (el.length === 0 || taberLink.length === 0) {
			return;
		}

		// Remove active class from all taber links
		taberLink.removeClass('is-active');

		// Add active class to corresponding taber link based on href
		taberLink.filter(`[href="${href}"]`).addClass('is-active');

		// Trigger click on the taber link to show corresponding content
		taberLink.filter(`[href="${href}"]`).trigger('click');

		// Scroll to section based on href
		const targetSection = $(href);
		if (targetSection.length) {
			const headerHeight = $('.header').outerHeight();
			const targetOffset = targetSection.offset().top - headerHeight;

			$('html, body').animate(
				{
					scrollTop: targetOffset,
				},
				500
			);
		}
	}

	init();
};
